var map = {
	"./Member_01.svg": 90144,
	"./example": 87398,
	"./example.json": 87398,
	"./skirt_correct.png": 79540,
	"./skirt_correct_horizontal.png": 36977,
	"./skirt_error.png": 86359,
	"./skirt_error_horizontal.png": 82265,
	"./suit_correct.png": 95989,
	"./suit_correct_horizontal.png": 10078,
	"./suit_error.png": 96209,
	"./suit_error_horizontal.png": 95421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87622;